import HeroSection from './HeroSection.vue';
import BannerSection from './BannerSection.vue';
import QuickAccessSection from './QuickAccessSection.vue';
import GradesSection from './GradesSection.vue';
import HomeProductsSection from './HomeProductsSection.vue';
import StatsSection from './StatsSection.vue';
import TestimonialsSection from './TestimonialsSection.vue';
import CtaSection from './CtaSection.vue';

/**
 * Maps a homepage_sections `type` to the real Vue component that renders it
 * — an object map, not an if/else chain, so index.vue can do
 * `<component :is="sectionRegistry[s.type]">` in a single v-for loop.
 * `header`/`footer` are intentionally absent — they're global chrome
 * (navbar.vue / App.vue+footer.vue), not part of this per-page loop.
 */
export const sectionRegistry = {
  hero: HeroSection,
  banners: BannerSection,
  quick_access: QuickAccessSection,
  academic_systems: GradesSection,
  home_products: HomeProductsSection,
  statistics: StatsSection,
  testimonials: TestimonialsSection,
  cta: CtaSection,
};
